import { render } from "./Show.vue?vue&type=template&id=db7eb3d0&scoped=true"
import script from "./Show.vue?vue&type=script&lang=ts"
export * from "./Show.vue?vue&type=script&lang=ts"

import "./Show.vue?vue&type=style&index=0&id=db7eb3d0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-db7eb3d0"

export default script